module.exports = __webpack_public_path__ + "img/服务客户.342c749c.png";